import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useUDFilters( name ) {
   return useFetchData({
      APIMethod: API.getUDFilters,
      condition: !!name,
      cache_name: name + "-ud-filters",
      params: [ name ]
   })
}